<template>
    <div class="fill-height of-y d-flex flex-column" style="overflow-x: auto; width: 100%">
        <div class="flex-grow-0 pa-2 d-flex justify-space-between align-center">
            <div>
                <v-btn
                    color="primary"
                    small
                    :loading="loading"
                    :disabled="loading"
                    @click="refreshReportData"
                    class="mr-2"
                >
                    Refresh
                </v-btn>
                <v-btn
                        :disabled="false"
                        @click="exportData"
                        color="primary"
                        small
                        :loading="exportingData"
                >
                    Export
                </v-btn>
            </div>
            <div style="width: 30%">
                <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="pa-0 ma-0"
                ></v-text-field>
            </div>
        </div>
        <div class="flex-grow-1 of-y" style="overflow-x: auto; width: 100%">

            <div class="fill-height d-flex align-center justify-center" v-if="loading">
                <loader></loader>
            </div>

            <div v-else style="width: 1920px" class="fill-height of-y">
                <v-data-table
                    :search="search"
                    dense
                    fixed-header
                    height="100%"
                    class="fill-height of-y"
                    hide-default-footer
                    :headers="headers"
                    :items="rows"
                    :options="{itemsPerPage: rows.length}"
                >
                    <template #item.fkSignedDoc="{item}">
                        <v-btn
                            icon
                            small
                            :disabled="fetchingWarning"
                            :loading="fetchingWarning"
                            @click="downloadWarning(item)"
                            color="secondary"
                        >
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </template>
                    <template #item.issued="{item}">{{format(new Date(item.issued), 'yyyy-MM-dd hh:mm')}}</template>
                    <template #item.signedDate="{item}">{{format(new Date(item.signedDate), 'yyyy-MM-dd hh:mm')}}</template>
                    <template #item.signedLocation="{item}">
                        <span class="caption" v-html="item.signedLocation.split(',').join('<br>')"/>
                    </template>
                    <template #item.offenceTitle="{item}">
                        <span class="caption" v-html='item.offenceTitle.replace(/^"|"$/gm, "")'/>
                    </template>
                </v-data-table>

            </div>

        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";
import Loader from "@/components/General/Loader/Loader.vue";
import {exportStats} from "@/core/codeFunctions";

export default {
    components: {Loader},
    props: {
        reportType: String,
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            format,
            exportingData: false,
            search: null,
            headers: [
                {value: "fkSignedDoc", text: "", width: 30},
                {value: "empCode", text: "Clock No"},
                {value: "fullName", text: "Name"},
                {value: "idNo", text: "Id/Passport No."},
                {value: "farm", text: "Farm"},
                {value: "warning", text: "Warning"},
                {value: "offenceTitle", text: "Charge"},
                {value: "dateOfOffence", text: "Offence Date"},
                {value: "offenceNo", text: "Offence No."},
                {value: "issued", text: "Issued"},
                {value: "age", text: "Age"},
                {value: "employeeStatus", text: "Employee Status"},
                {value: "signedDate", text: "Signed"},
                {value: "signedLocation", text: "Signed Location"},
                {value: "issuedBy", text: "Issued By"},
                // {value: "lastModifiedBy", text: "LastModifiedBy"},
                // {value: "modified", text: "Modified"},
                // {value: "fkFarm", text: "FkFarm"},
                // {value: "fkEmp", text: "FkEmp"},
            ],
            loading: false,
            data: [],
            fetchingWarning: false
        }
    },

    mounted() {
        this.refreshReportData();
    },

    methods: {

        async downloadWarning(row) {
            try {
                this.fetchingWarning = true;
                await this.$newReqDownloadFile("POST",'setup/emp/getWarning', {id: row.fkSignedDoc}, `${row.empCode} ${row.warning} ${format(new Date(row.issued), 'yy-mm-dd')}.pdf`)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.fetchingWarning = false
            }
        },

        async refreshReportData() {
            try {
                this.loading = true
                this.data = await this.$newReq('POST', 'reports/warnings/complete', {})
            } catch (e) {
                console.log(e)
            } finally {
                this.loading = false
            }

        },

        exportData() {
            const data = this.rows.map(row => {
                return {
                    ...row,
                    issued: format(new Date(row.issued), 'yyyy-MM-dd hh:mm'),
                    signedDate: format(new Date(row.signedDate), 'yyyy-MM-dd hh:mm')
                }
            });

            exportStats(`Signed Warnings${this.selectedFarm ? ' for ' + this.farmsRef[this.selectedFarm].description + ' ' : ''} ${format(Date.now(), 'yyyy-MM-dd hh_mm')}`, 'Warnings', this.headers.filter(header => header.value !== 'fkSignedDoc'), data)
        },
    },
    computed: {
        ...mapGetters(["farms", "availableFarms", "availableFarmIDs", "farmsRef"]),
        rows() {
            return this.data
                    .filter((row) => row && this.selectedFarm ? row.fkFarm === this.selectedFarm : true)
                    .filter(row => row.farmID ? this.availableFarmIDs.includes(row.farmID) : true)
        }
    },
}
</script>

<style scoped>

</style>